import React, { useMemo, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import styles from "./LoginSchoolScreen.module.scss";
import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import SelectInput from "../../components/SelectInput/SelectInput";
import {
  selectChoosenSchool,
  selectSchools,
  setChoosenSchool,
} from "../../store/slices/school/slice";
import { fetchSchools } from "../../store/slices/school/asyncThunks";

const LoginSchoolScreen = () => {
  const choosenSchool = useSelector(selectChoosenSchool);
  const schools = useSelector(selectSchools);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const validateInputData = useMemo(() => {
    if (choosenSchool.name.trim().length > 0) {
      return true;
    } else {
      return false;
    }
  }, [choosenSchool]);

  useEffect(() => {
    dispatch(fetchSchools());
  }, [dispatch]);

  const setOption = (option) => {
    dispatch(setChoosenSchool(option));
  };

  const goToLoginPage = () => {
    if (choosenSchool.name.trim().length > 0) {
      navigate("/login", { state: location.state });
    } else {
      alert("Please select a school");
    }
  };

  return (
    <div className={styles.loginScreenContainer}>
      <div className={styles.card}>
        <Card>
          <div className={styles.loginCardContainer}>
            <div>
              <h1>Welcome!</h1>
              <h2>Search for your school</h2>
            </div>

            <div className={styles.selectInputContainer}>
              <SelectInput
                id="selectInputSchool"
                label="School name"
                options={schools}
                currentValue={choosenSchool}
                setOption={setOption}
              />
            </div>
            <div className={styles.buttonContainer}>
              <Button
                aria-label="Login"
                title="Continue"
                disabled={!validateInputData}
                onClick={() => goToLoginPage()}
              />
            </div>
          </div>
        </Card>
      </div>
      <h3>Powered by Aware Technology</h3>
    </div>
  );
};

export default LoginSchoolScreen;
